import * as React from 'react';
import classNames from 'classnames';
import './styles.scss';

export interface ILayoutFormProps {
    /** Layout to use */
    layout?: 'default' | 'wide' | 'filter' | 'vertical' | 'details';
    /** Hide labels */
    hideLabels?: boolean;
    /** Display readonly */
    readonly?: boolean;
}

interface IState {
}

/**
 * Basic form wrapper.
 */
class LayoutForm extends React.Component<ILayoutFormProps, IState> {
    static displayName: string = 'LayoutForm';

    render () {
        let hasColumns = false;

        React.Children.map(this.props.children, (child: any) => {
            if (typeof child === 'string' || child === null || !child.type || !child.type.displayName) {
                return;
            } else if (child.type.displayName === 'LayoutFormColumn') {
                hasColumns = true;
            }
        });

        return (
            <div className={classNames('layout-form', {
                'layout-form-default': this.props.layout === 'default' || !this.props.layout,
                'layout-form-vertical': this.props.layout === 'vertical',
                'layout-form-wide': this.props.layout === 'wide',
                'layout-form-filter': this.props.layout === 'filter',
                'layout-form-details': this.props.layout === 'details',
                'layout-form-has-columns': hasColumns,
                'layout-form-nolabels': this.props.hideLabels,
            })}>
                {this.props.children}
            </div>
        );
    }
}

export default LayoutForm;
